import { render, staticRenderFns } from "./AvailabilityRequest.vue?vue&type=template&id=677478fa"
import script from "./AvailabilityRequest.vue?vue&type=script&lang=js"
export * from "./AvailabilityRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports